<template>
  <basic-container>
    <div style="width: 1000px">
      <el-form ref="ruleForm" :model="data" :rules="rules" label-width="110px">
        <el-form-item label="税率" prop="taxRate">
          <div style="display: flex; align-items: center">
            <el-input v-if="hasCheck" v-model="num" type="number" style="width: 300px" />
            <span v-else>{{ num }}</span>
            &nbsp;%

            <div style="margin-left: 20px">
              <div style="color: red; font-size: 12px; line-height: 16px">
                用于渠道佣金结算计算：
                <br />
                佣金=完单订单的实际收款金额（扣除退款、优惠券等）/(1+税率 ）x 佣金比例
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <div style="margin-bottom: 10px; padding-left: 20px">最新操作人：{{ data.username }}</div>
      <div style="margin-bottom: 10px; padding-left: 20px">操作时间：{{ data.updateTime }}</div>

      <div style="padding-left: 300px" v-has-permi="['channel_taxrate_save']">
        <el-button :loading="loading" type="primary" @click="submitForm('ruleForm')">
          保存
        </el-button>
      </div>
    </div>
  </basic-container>
</template>

<script>
  import { getTaxRateInfo, postTaxRateSave } from '@/api/channel'
  import store from '@/store'
  export default {
    data() {
      // const validateTaxRate = (rule, value, callback) => {
      //   const reg = /^[1-9]\d*(\.\d+)?$|^0\.\d*[1-9]\d*$/
      //   if (!reg.test(value)) {
      //     callback(new Error('请输入大于0的数字'))
      //   } else {
      //     callback()
      //   }
      // }
      return {
        loading: false,
        rules: {
          // taxRate: [
          //   { required: true, message: '请输入税率', trigger: 'blur' },
          //   { validator: validateTaxRate, trigger: 'blur' }
          // ]
        },
        data: {},
        num: 0,
        hasCheck: false
      }
    },
    created() {
      this.init()
      const permissions = store.getters && store.getters.acpermission
      this.hasCheck = permissions.some((permission) => {
        return permission === 'channel_taxrate_save'
      })
    },

    methods: {
      async init() {
        const res = await getTaxRateInfo()
        if (res.code === 0) {
          this.num = res.data.taxRate / 100
          this.data = res.data
        }
      },

      submitForm(formName) {
        // this.$refs[formName].validate((valid) => {
        //   if (valid) {
        const regex = /^\+?(0+(\.0+)?|0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)([eE][+-]?\d+)?$/
        if (!regex.test(this.num)) {
          this.$message.error('请输入正确的数字')
          return
        }
        this.$confirm('修改后将立即生效，是否确认修改？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async () => {
            const data = {
              taxRate: this.num * 100
            }
            const res = await postTaxRateSave(data)
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.init()
            }
          })
          .catch(() => {})
        //   }
        // })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
